import { render, staticRenderFns } from "./TShirts.vue?vue&type=template&id=5f0b7f48&scoped=true"
import script from "./TShirts.vue?vue&type=script&lang=js"
export * from "./TShirts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0b7f48",
  null
  
)

export default component.exports